import * as actions from './budget/actions'
import * as mutations from './budget/mutations'
import * as getters from './budget/getters'

import { props } from './budget/properties'

const state = {
    filterText: '',
    prop: JSON.parse(JSON.stringify(props)),
    event_types: [],
    financial_configuration: null,
    looking_for_budget: false
}

export default {
    state,
    actions,
    mutations,
    getters
}


// WEBPACK FOOTER //
// ./src/store/modules/budget.js